import React, { useState } from "react";
import { Layout, Row, Col, Typography } from "antd";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
import { BRAND_NAME } from "config/config";

const LayoutFooter = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Layout.Footer>
      <Row>
        <Col align="center" span={24}>
          <Typography.Text type="secondary">{BRAND_NAME}</Typography.Text>
        </Col>
        <Col align="center" span={24}>
          <div className="flex items-center justify-center gap-2 text-center text-gray-500">
            <a
              className="hover:text-gray-600 hover:underline"
              href="/term-of-service"
            >
              Điều khoản dịch vụ
            </a>{" "}
            |{" "}
            <a
              className="hover:text-gray-600 hover:underline"
              href="/privacy-policy"
            >
              Chính sách bảo mật
            </a>
          </div>
        </Col>
        <Col align="center" span={24}>
          <Typography.Text type="secondary">© Powered by ViVN</Typography.Text>
        </Col>
      </Row>
    </Layout.Footer>
  );
};
export default LayoutFooter;
